import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false, requireWorker = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center">
        <div className="text-center">
          <div className="w-10 h-10 border-4 border-[#3FA7D6] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
          <p className="text-[#6B7280] text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  // Admin only
  if (requireAdmin && user.role !== "admin") return <Navigate to="/dashboard" replace />;

  // Worker or admin trying to access restricted pages
  if (requireWorker && !["worker", "admin"].includes(user.role)) return <Navigate to="/dashboard" replace />;

  // Auto-redirect admins and workers away from the regular user dashboard
  if (!requireAdmin && !requireWorker && location.pathname === "/dashboard") {
    if (user.role === "admin") return <Navigate to="/admin" replace />;
    if (user.role === "worker") return <Navigate to="/worker" replace />;
  }

  return children;
}
